import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=68546214&scoped=true"
import script from "./add-product.vue?vue&type=script&lang=js"
export * from "./add-product.vue?vue&type=script&lang=js"
import style0 from "./add-product.vue?vue&type=style&index=0&id=68546214&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68546214",
  null
  
)

export default component.exports